import { createAction } from "@reduxjs/toolkit"

// Clear state action
export const resetStore = createAction('store/reset')